import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import TrustBadges from '../components/TrustBadges';
import ProcessSection from '../components/ProcessSection';
import ServicesGrid from '../components/ServicesGrid';
import WhyChooseUs from '../components/WhyChooseUs';
import ServiceArea from '../components/ServiceArea';
import SocialSection from '../components/SocialSection';
import SolutionsSection from '../components/SolutionsSection';
import ContactEvaluationSection from '../components/ContactEvaluationSection';
import Footer from '../components/Footer';

export const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <TrustBadges />
      <ProcessSection />
      <ServicesGrid />
      <WhyChooseUs />
      <ServiceArea />
      <SocialSection />
      <SolutionsSection />
      {/* <Testimonials /> */} {/* ── Hidden per client request — uncomment to restore */}
      <ContactEvaluationSection />
      <Footer />
    </div>
  );
};

export default HomePage;
